export interface ILoginProfile {
  CrmContactId: string;
  CrmCountry: string;
  Roles: string[];
}

export interface ILoginRequestData {
  Login: string;
  Password: string;
  RememberMe: string;
  DuplicateProfileId: string;
}

export interface ILoginResponseData {
  IsAuthenticated: boolean;
  CustomerName: string;
  DuplicateProfiles: ILoginProfile[];
  DuplicateProfileId: string;
}

export interface ILoginResponseResolveData {
  authenticated: boolean;
  requiresSelection: boolean;
  customerName: string;
  profiles: ILoginProfile[];
}

export enum AuthenticateMode {
  Login,
  ForgotPassword,
  ForgotPasswordSuccess,
  ForgotPasswordUnknown,
  SelectProfile,
}

export interface IAuthenticatePartialComponent {
  show(...args: any[]): void;
  hide(): void;
  toggle(...args: any[]): void;
  querySelector(selector: string): HTMLElement;

  onSubmit(nextMode?: AuthenticateMode, ...args: any[]): void;
}
